export enum LicenseMachineEnum {
  LIGHT = 'LIGHT',
  PRO = 'PRO',
  ULTIMATE = 'ULTIMATE',
}
